import { jsxs as e, jsx as o } from "react/jsx-runtime";
const n = ({ className: t }) => /* @__PURE__ */ e(
  "svg",
  {
    width: "41",
    height: "41",
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: t,
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M21.2536 22.1111L23.9987 26.2778M23.9987 26.2778L26.7438 30.4444M23.9987 26.2778L26.7438 22.1111M23.9987 26.2778L21.2536 30.4444M30.1752 22.1111H32.9203M32.9203 22.1111H35.6654M32.9203 22.1111V30.4444M12.332 22.1111H15.0771M15.0771 22.1111H17.8222M15.0771 22.1111V30.4444",
          stroke: "#A8A29E",
          strokeWidth: "1.5",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M25.6667 37.1111H18.5455C13.1101 37.1111 10.3924 37.1111 8.50512 35.7814C7.96437 35.4004 7.4843 34.9485 7.0795 34.4396C5.66667 32.6633 5.66667 30.1055 5.66667 24.9899V20.7474C5.66667 15.8088 5.66667 13.3395 6.44823 11.3673C7.70469 8.19679 10.3619 5.69589 13.7306 4.51334C15.826 3.77775 18.4497 3.77775 23.697 3.77775C26.6954 3.77775 28.1946 3.77775 29.392 4.19808C31.317 4.87383 32.8354 6.30291 33.5534 8.11465C34 9.24162 34 10.6527 34 13.4747V17.1111",
          stroke: "#A8A29E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M5.66536 20.4445C5.66536 17.3762 8.15267 14.8889 11.2209 14.8889C12.3306 14.8889 13.6388 15.0833 14.7176 14.7943C15.6762 14.5374 16.425 13.7887 16.6818 12.8301C16.9709 11.7512 16.7765 10.443 16.7765 9.33335C16.7765 6.2651 19.2638 3.77779 22.332 3.77779",
          stroke: "#A8A29E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
export {
  n as TxtFileIcon
};
